import { AccountManagersRawData } from '../interfaces/accountManager';

export function AccountManagerContactsFactory(rawData?: AccountManagersRawData) {
  const contacts = [];

  if (!rawData) {
    return contacts;
  }

  if (rawData.technical_account_manager) {
    contacts.push({
      name: rawData.technical_account_manager.name,
      description: rawData.technical_account_manager.description,
      email: rawData.technical_account_manager.email,
      role: 'Technical Account Manager',
      palette: 'primary'
    });
  }

  if (rawData.account_manager) {
    contacts.push({
      name: rawData.account_manager.name,
      description: rawData.account_manager.description,
      email: rawData.account_manager.email,
      role: 'Account Manager',
      palette: 'warning'
    });
  }

  return contacts;
}
